// Port z partials.js linie 909-921 (bindStickyHeader).

export function initStickyHeader() {
  const wrap = document.getElementById('site-header-wrap');
  if (!wrap) return;
  // rAF-throttled — Safari iOS dławi się gdy `getBoundingClientRect()` + style write
  // odpalają na każde scroll event (60-120/sec); ticking guard kolapsuje burst do 1/frame.
  let ticking = false;
  let lastFloating = null;
  let lastTop = null;
  const update = () => {
    ticking = false;
    const y = window.scrollY || document.documentElement.scrollTop;
    const isFloating = y > 40;
    if (isFloating !== lastFloating) {
      wrap.classList.toggle('is-floating', isFloating);
      lastFloating = isFloating;
    }
    // Przy otwartej wyszukiwarce punkt zaczepienia jest zamrożony — nagłówek stoi przypięty,
    // a panel ma być nieruchomy. Nadpisywanie go tutaj cofałoby przypięcie na każdej klatce.
    if (document.documentElement.classList.contains('kb-search-open')) return;
    const newTop = wrap.getBoundingClientRect().bottom;
    if (newTop !== lastTop) {
      document.documentElement.style.setProperty('--mega-top', newTop + 'px');
      lastTop = newTop;
    }
  };
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
}

// Marquee pause gdy out of view — Safari iOS trzyma compositor layer
// dla `will-change-transform` na ekranie nawet gdy element zjedzie ponad
// viewport, akumulując GPU memory. IO toggle stops animation when off-screen.
function initMarqueePause() {
  const bar = document.getElementById('site-announcement');
  if (!bar || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      bar.classList.toggle('kb-in-view', e.isIntersecting);
    }
  }, { threshold: 0 });
  io.observe(bar);
  // Initial — przed pierwszym callbackiem traktujemy jako visible (gdy user
  // wylądował na top page). Bez tego marquee startuje "paused".
  bar.classList.add('kb-in-view');
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') { initStickyHeader(); initMarqueePause(); }
  else document.addEventListener('DOMContentLoaded', () => { initStickyHeader(); initMarqueePause(); });
}
